import React, { forwardRef } from 'react';
import { InputDefaultContainer, InputDefaultLabel, InputDefaultField, InputDefaultMessageError } from './styles';

const InputDefault = forwardRef((props, ref) => {
  return (
    <InputDefaultContainer id="input-text">
      <InputDefaultLabel htmlFor={props.id}>{props.label}</InputDefaultLabel>
      <InputDefaultField
        name={props.name}
        defaultValue={props.value}
        ref={props.register}
        className={props.error && 'error'}
        readOnly={props.readOnly}
        onChange={props.onChange}
        onClick={props.onClick}
        autoComplete={props.autoComplete}
        maxLength={props.maxLength}
        minLength={props.minLength}
        id={props.id}
        type={props.type}
        onBlur={props.onBlur}
        onCopy={props.onCopy}
        onPaste={props.onPaste}
        register={props.register}
      />
      {props.error && <InputDefaultMessageError error={props.error}>{props.error.message}</InputDefaultMessageError>}
    </InputDefaultContainer>
  )
})

export default InputDefault